import React, { Fragment } from "react";
import { withStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import styles from "../../styles";
import { withSnackbar } from "notistack";
import { postData } from "../../../../../api/componentAPIs";
import DataGrid from "../../../../dataGrid";
import GridConfig from "./gridConfig";
import CircularProgress from "@material-ui/core/CircularProgress";
class CustomStepper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: 0,
      completed: new Set(),
      uploading: false,
      isValidationErrorMessage: false,
      errorMessage: null,
    };
  }
  onGridReady = ({ api }) => {
    this.gridApi = api;
  };

  isStepOptional = (step) => {
    return step !== this.totalSteps() - 1;
  };

  totalSteps = () => {
    return this.props.steps.length;
  };

  lastStepCompleted = () => {
    return this.state.completed.has(this.totalSteps() - 1);
  };

  isLastStep = () => {
    return this.state.activeStep === this.totalSteps() - 1;
  };

  handleNext = () => {
    if (this.isLastStep() && this.lastStepCompleted()) {
      this.props.enqueueSnackbar("File Upload Process completed.", {
        variant: "success",
        preventDuplicate: true,
      });
      return;
    }
    this.isLastStep() && !this.lastStepCompleted()
      ? this.props.enqueueSnackbar(
          "Input shipment file is required to complete the upload process.",
          { variant: "error", preventDuplicate: true }
        )
      : this.setState((previousState) => {
          return {
            ...previousState,
            activeStep: previousState.activeStep + 1,
            isValidationErrorMessage: false,
            errorMessage: null,
          };
        });

    // It's the last step, but not all steps have been completed
    // find the first step that has been completed
    //   this.props.steps.findIndex((step, i) => !this.state.completed.has(i))
    // : this.state.activeStep + 1;
    // this.setState((previousState) => {
    //   return { ...previousState, activeStep: };
    // });
    // this.setState({
    //   activeStep: newActiveStep,
    // });
  };

  handleBack = () => {
    this.setState((previousState) => {
      return {
        ...previousState,
        activeStep: previousState.activeStep - 1,
        isValidationErrorMessage: false,
        errorMessage: null,
      };
    });
  };

  handleStep = (step) => () => {
    this.setState({
      activeStep: step,
      isValidationErrorMessage: false,
      errorMessage: null,
    });
  };

  handleComplete = () => {
    const newCompleted = new Set(this.state.completed);
    newCompleted.add(this.state.activeStep);
    this.setState({
      completed: newCompleted,
    });

    this.handleNext();
  };

  isStepComplete(step) {
    return this.state.completed.has(step);
  }

  getStepContent(step) {
    return this.props.steps[step].stepName;
  }
  getStepAPI(step) {
    return this.props.steps[step].stepAPI;
  }

  removeDuplicateErrorProperty = (property, err) => {
    let errMsg = Object.values(err.constraints)[0];
    errMsg = errMsg.replace(/(\$value)/g, "");
    if (errMsg.toLowerCase().includes(property.toLowerCase())) {
      return errMsg;
    }
    return `${err.property} ${errMsg}`;
  };

  getFormattedValidationError = (error) => {
    this.gridConfig = new GridConfig(
      null,
      this.props.steps[this.state.activeStep].stepAPI
    );
    let formattedErrorArr = [];
    let obj = {};
    error.data.error.details.forEach((error) => {
      const identityKey = Object.keys(error)[0];
      const identityKeyValue = Object.values(error)[0];
      error.error.forEach((err) => {
        let formattedErrMsg = this.removeDuplicateErrorProperty(
          err.property,
          err
        );
        obj[`${identityKey}`] = identityKeyValue;
        obj["error"] = formattedErrMsg;
        formattedErrorArr.push(obj);
        obj = {};
      });
    });
    return formattedErrorArr;
  };

  handleFileUploadError = (error) => {
    this.props.enqueueSnackbar("File Upload Failed", {
      variant: "error",
    });

    if (error.data.error.message === "Validation Error") {
      let errors = this.getFormattedValidationError(error);
      this.setState((prevState) => {
        return {
          uploading: !prevState.uploading,
          isValidationErrorMessage: true,
          errorMessage: errors,
        };
      });
    } else {
      this.setState((prevState) => {
        return {
          uploading: !prevState.uploading,
          isValidationErrorMessage: false,
          errorMessage: error.data.error.message,
        };
      });
    }
  }

  handleFileUpload = ({ target }) => {
    const formData = new FormData();

    formData.append("file", target.files[0]);

    this.setState((prevState) => {
      return {
        uploading: !prevState.uploading,
      };
    });

    postData(this.getStepAPI(this.state.activeStep), formData).then(
      (response) => {
        if (response && Math.trunc(response.status/100) === 2) {
          this.props.enqueueSnackbar("File Uploaded Successfully", {
            variant: "success",
          });
          this.setState((prevState) => {
            return {
              uploading: !prevState.uploading,
              isValidationErrorMessage: false,
              errorMessage: null,
            };
          });
          this.handleComplete();
        }
        else {
          this.handleFileUploadError(response?.response)
        }
      },
      (error) => {
       this.handleFileUploadError(error)
      }
    );
  };

  render() {
    const { steps, classes } = this.props;
    const {
      activeStep,
      completed,
      uploading,
      isValidationErrorMessage,
      errorMessage,
    } = this.state;
    return (
      <Fragment>
        <div id="uploadBox" className={classes.uploadBox}>
          <div className={classes.mainStepperContainer.root}>
            <Stepper alternativeLabel nonLinear activeStep={activeStep}>
              {steps.map((label, index) => {
                const stepProps = {};
                const buttonProps = {};
                if (this.isStepOptional(index)) {
                  buttonProps.optional = (
                    <Typography variant="caption">Optional</Typography>
                  );
                } else {
                  buttonProps.optional = (
                    <Typography variant="caption" color="error">
                      * (Required)
                    </Typography>
                  );
                }
                return (
                  <Step key={label.stepName} {...stepProps}>
                    <StepButton
                      disabled={uploading === true}
                      onClick={this.handleStep(index)}
                      completed={this.isStepComplete(index)}
                      {...buttonProps}
                    >
                      {label.stepName}
                    </StepButton>
                  </Step>
                );
              })}
            </Stepper>
          </div>

          <div
            id="fileUploadButtonContainer"
            className={classes.fileUploadButtonContainer}
          >
            {activeStep !== steps.length && completed.has(activeStep) && (
              <Typography variant="caption" className={classes.completed}>
                File upload successful.Data loading is in progress.
              </Typography>
            )}
            {!uploading ? (
              <div>
                <input
                  accept=".csv,.xlsx,.xls"
                  style={{ display: "none" }}
                  id="contained-button-file"
                  single
                  type="file"
                  onChange={(e) => this.handleFileUpload(e)}
                />
                <label htmlFor="contained-button-file">
                  <Button
                    variant="contained"
                    color="primary"
                    component="span"
                    classes={{
                      root: `${classes.actionButton} ${classes.stepperButton}`,
                      disabled: classes.actionDisabled,
                    }}
                  >
                    {`Upload ${steps[activeStep].stepName}`}
                  </Button>
                </label>
              </div>
            ) : (
              <CircularProgress size={18} />
            )}
          </div>
          {isValidationErrorMessage && !uploading && (
            <div className={classes.fileImportGridContainer}>
              <div className={`${classes.dataGrid}`}>
                <DataGrid
                  defaultColDef={this.gridConfig.config.defaultColDef}
                  columnDefs={this.gridConfig.config.columns}
                  config={this.gridConfig.config}
                  enableFilter={this.gridConfig.config.enableFilter}
                  enableSorting={this.gridConfig.config.enableSorting}
                  rowData={errorMessage}
                  onGridReady={this.onGridReady}
                  onCellValueChanged={this.onCellValueChanged}
                />
              </div>
            </div>
          )}
          {!isValidationErrorMessage && (
            <div className={classes.fileImportErrorContainer}>
              {errorMessage ? <h5>{errorMessage}</h5> : null}
            </div>
          )}
        </div>

        <div id="stepperButtons" className={classes.stepperButtonsContainer}>
          <div>
            <Button
              disabled={activeStep === 0}
              onClick={this.handleBack}
              className={classes.mainStepperContainer.button}
            >
              Back
            </Button>

            <Button
              variant="contained"
              color="primary"
              size="small"
              disabled={uploading === true}
              onClick={this.handleNext}
              classes={{
                root: `${classes.actionButton} ${classes.stepperButton}`,
                disabled: classes.actionDisabled,
              }}
            >
              {activeStep === steps.length - 1 ? "Finish" : "Next Import"}
            </Button>

            {!this.isLastStep() && this.lastStepCompleted() ? (
              <Button
                variant="contained"
                color="primary"
                size="small"
                disabled={uploading === true}
                onClick=""
                classes={{
                  root: `${classes.actionButton} ${classes.stepperButton}`,
                  disabled: classes.actionDisabled,
                }}
              >
                Finish
              </Button>
            ) : null}
          </div>
        </div>
      </Fragment>
    );
  }
}

export default withSnackbar(withStyles(styles)(CustomStepper));
